import { Component } from '@angular/core';

import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';

import { EmptyComponent } from '@camelot/ui';

@Component({
  selector: 'cam-ag-grid-no-rows',
  templateUrl: './no-rows-overlay.component.html',
  styleUrl: './no-rows-overlay.component.scss',
  imports: [EmptyComponent],
})
export class NoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  public params!: INoRowsOverlayParams;

  agInit(params: INoRowsOverlayParams): void {
    this.params = params;
  }
}
